(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lln-product-feed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();

    function initialize(root) {
      if (instances.has(root)) return;
      const track = root.querySelector('[data-feed-track]');
      const previous = root.querySelector('[data-feed-previous]');
      const next = root.querySelector('[data-feed-next]');
      const controls = root.querySelector('[data-feed-controls]');
      if (!track || !previous || !next || !controls) return;

      let frame = 0;
      const update = () => {
        frame = 0;
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const position = Math.min(maximum, Math.max(0, Math.abs(track.scrollLeft)));
        controls.hidden = maximum <= 2;
        previous.disabled = position <= 2;
        next.disabled = maximum - position <= 2;
      };
      const queueUpdate = () => {
        if (!frame) frame = window.requestAnimationFrame(update);
      };
      const move = (direction) => {
        const tile = track.querySelector('[data-feed-tile]');
        if (!tile) return;
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const distance = tile.getBoundingClientRect().width + gap;
        const rtl = window.getComputedStyle(track).direction === 'rtl';
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({
          left: distance * direction * (rtl ? -1 : 1),
          behavior: reduced ? 'auto' : 'smooth',
        });
      };
      const goPrevious = () => move(-1);
      const goNext = () => move(1);

      previous.addEventListener('click', goPrevious);
      next.addEventListener('click', goNext);
      track.addEventListener('scroll', queueUpdate, { passive: true });
      const resizeObserver = window.ResizeObserver ? new ResizeObserver(queueUpdate) : null;
      if (resizeObserver) resizeObserver.observe(track);
      else window.addEventListener('resize', queueUpdate);
      update();

      instances.set(root, () => {
        previous.removeEventListener('click', goPrevious);
        next.removeEventListener('click', goNext);
        track.removeEventListener('scroll', queueUpdate);
        if (resizeObserver) resizeObserver.disconnect();
        else window.removeEventListener('resize', queueUpdate);
        if (frame) window.cancelAnimationFrame(frame);
      });
    }

    function initializeWithin(scope) {
      if (scope.matches && scope.matches('[data-lln-product-feed]')) initialize(scope);
      scope.querySelectorAll('[data-lln-product-feed]').forEach(initialize);
    }

    function unloadWithin(scope) {
      for (const [root, cleanup] of instances) {
        if (root === scope || scope.contains(root)) {
          cleanup();
          instances.delete(root);
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
    } else initializeWithin(document);

    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => unloadWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
